import { useApp } from '../../context/AppContext.jsx'
import TaskPanel from './TaskPanel.jsx'

/** A criação usa o mesmo modal e os mesmos editores dos detalhes da tarefa. */
export default function AddOperationTaskPopover({ initialProjectId, onClose, onCreated }) {
  const { toast } = useApp()
  return <TaskPanel creating initialProjectId={initialProjectId} onClose={onClose} onCreated={task => {
    toast('Tarefa criada.', 'success')
    onCreated(task)
  }}/>
}
